import momentJs from 'moment';
export var stage = {
	token: '', // 临时token，将优先使用，并改变一些业务逻辑
	// origin:location.origin,
	// path:(location.hostname=="localhost")?"":"",
	// path:"E:/Azrael/work/apache-tomcat-7.0.57/webapps/cross/",
	// pathEX:"static/",

	// fileType:".html",//默认加载的文件类型
	loc: {// 使用本地化资源
		logo: {
			login: {
				public: ''// 默认logo，找不到就会使用这个
			}, // 登录用
			system: {
				public: ''// 默认logo，找不到就会使用这个
			}// 登录后用
		},
		// language:false,//true:子页面独立加载语言资源
		loginSystem: {// 登录体系设定
			sha256: true,
			out: {// 针对外部登录系统的场景，判断退到目标页面
				// test:{//测试
				// 	host:["fls-pvam-stg1.paic.com.cn"],
				// 	url:"https://pacas-stg1.paic.com.cn/cas/PA026/FLS_CBS_STG1/login",
				// 	data:{
				// 		appId:"9e84d8e16578f27001657a89ac62004d"
				// 	}
				// },
				// prod:{//正式
				// 	host:[
				// 		"fls-pvam.paic.com.cn",
				// 		"fls-pvam-dr.paic.com.cn"//备用环境
				// 	],
				// 	url:"https://pacas-super.paic.com.cn/cas/PA026/FLS_PVAM/login",
				// 	data:{
				// 		appId:"9e90f847658b6ddb0165c683e144002a"
				// 	}
				// }
			}
		},
		baseRouter: '/', // 对子路径的场景配置
		accountFirstUse: 'eMail', // 账号优先方式
		customer: 'SOLARMAN', // 部分功能会针对固定客户开放
		customerDisplay: {// 用来展示的定制化名称
			public: '',
			zh: '',
			en: '',
			pt: '',
			es: '',
			nl: '',
			pl: '',
			ko: '',
			vi: ''
		},
		platformName: '', // 后端定义的平台名称
		platformCode: '', // 后端定义的平台code
		operationManual: {// 头部操作手册地址
			public: '',
			zh: '',
			en: '',
			pt: '',
			es: '',
			nl: '',
			pl: '',
			ko: '',
			vi: ''
		},
		statistic: {// 网站统计代码地址
			baidu: ''
		},
		key: {// 各种第三方api的key
			// SOLARMAN:{
			amap: '19cacba68756210399cfed0012e65e05',
			google: 'AIzaSyBYU8ULYLFlMvsJoRkJBgJAxZ5RS7eleXg'// AIzaSyCesEqmd-_MPYsZUlCC3RmKebNZXtaHoVA
			// }
		},
		ip: '', // 记录用户ip
		ipCountry: ''// 记录用户IP所在国家
	},
	space: parseInt($('html').css('font-size')), // 页面1em的大小

	powerTypeList: [], // 记录当前账号可用的能源类型

	type: {
		b: '/login',
		c: false
	}, // b：B端运行；b：C端运行
	typeChange: false, // 是否可切换模式
	//	frame:"",
	// class:"",//页面的总类别:plant,device,report,config....
	// targetPage:"",//需要加载的子页面

	time: {
		date: '',
		dateFix: 0,
		timeZone: '',
		localTimeZone: momentJs().format('Z'),
		offset: 0,
		localOffset: -new Date().getTimezoneOffset() * 60 * 1000,
		utc: 0,
	  week: '',
		timezoneMap: {}
	},

	setting: {// 设置
		loc: {
			sideMode: 'def', // 侧边菜单的显示模式，"min"：最小化
			operateMode: 'def', // 列表操作列的展示模式
			listMode: 'list', // 列表模式|地图模式(光伏电站)
			windListMode: 'list', // 列表模式|地图模式(风力电站)
			privacyStatementUrl: {// 服务协议声明的跳转链接
				// zh: 'http://www.solarman.cn/privacy.html',
				// en: 'http://www.solarman.cn/en/privacy.html',
				// pt: 'http://www.solarman.cn/en/privacy.html',
				// pl: 'http://www.solarman.cn/en/privacy.html',
				// es: 'http://www.solarman.cn/en/privacy.html',
				// nl: 'http://www.solarman.cn/en/privacy.html',
				// fr: 'http://www.solarman.cn/en/privacy.html'
			},
			privacyPolicyUrl: {// 隐私协议声明的跳转链接
				// zh: 'https://protocol.solarmanpv.com/SOLARMAN/privacy_cn.html',
				// en: 'https://protocol.solarmanpv.com/SOLARMAN/privacy_en.html',
				// pt: 'https://protocol.solarmanpv.com/SOLARMAN/privacy_en.html',
				// pl: 'https://protocol.solarmanpv.com/SOLARMAN/privacy_en.html',
				// es: 'https://protocol.solarmanpv.com/SOLARMAN/privacy_en.html',
				// nl: 'https://protocol.solarmanpv.com/SOLARMAN/privacy_en.html',
				// fr: 'https://protocol.solarmanpv.com/SOLARMAN/privacy_en.html'
			},
			'2in1': {
				cover: {
					b: `static/image/2in1/b.png`,
					c: `static/image/2in1/c.png`
				}
				// file:{
				// 	b:{
				// 		web:{
				// 			zh:["完整版地址","简易版地址"],
				// 			en:["完整版地址","简易版地址"],
				// 			pt:["完整版地址","简易版地址"],
				// 			es:["完整版地址","简易版地址"]
				// 		},
				// 		app:{
				// 			zh:["完整版地址"],
				// 			en:["完整版地址"],
				// 			pt:["完整版地址"],
				// 			es:["完整版地址"]
				// 		}
				// 	},
				// 	c:{
				// 		web:{
				// 			zh:["完整版地址"],
				// 			en:["完整版地址"],
				// 			pt:["完整版地址"],
				// 			es:["完整版地址"]
				// 		},
				// 		app:{
				// 			zh:["完整版地址"],
				// 			en:["完整版地址"],
				// 			pt:["完整版地址"],
				// 			es:["完整版地址"]
				// 		}
				// 	}
				// },
				// notice:{
				// 	zh:"",
				// 	en:"",
				// 	pt:"",
				// 	es:""
				// }
			},
			shieldBlackList: {// 功能屏蔽黑名单
				message: false, // 消息功能
				inspect: false, // 体检
				maintenance: false, // 维保记录
				report: false, // 报表
				display: false, // 大屏
				plantPhoto: false, // 电站照片
				networking: false, // 组网应用
				batchTask: false, // 批量任务
				managemessage: false, // 报警消息
				plantLayout: false// 电站组件布局
			},
			shieldWhiteList: {// 功能开启白名单
				Announcement: false, // 公告
				app: {
					electricity: false, // 电费记录
					IVCurveItemStruct: false// IV曲线
				},
				mapMode: {}, // 各个地图模式
				orderManagement: false // 指令管理
			},
			AC_name: {
				title: 'word1178',	// 交流
				list: ['R', 'S', 'T']
			}
			// appQR:{//app下载二维码地址
			// },
			// replaceUrl:[//替换url
			// 	{
			// 		from:["/"],
			// 		to:`/`
			// 	}
			// ]
		},
		system: {
			autoColumnWidth: [15, 'em']// 每个表格列宽
		}
	},
	// backgroundImage:{//背景图片设置
	// 	login:``,//登录页面
	// },
	color: {
		main: '#0093ff',
		// blue: "#0093ff",
		 blueLight: '#3badf6',
		blueDark: '#5383ed',
		redLight: '#ff595f',
		// red: "#ff595f",
		redDark: '#ff262d',
		yellowLight: '#ffb93d',
		yellowDark: '#fb9678',
		// green: "#21ad5c",
		greenLight: '#0ccfc5',
		greenDark: '#30c790',
		// orange: "#fc7304",
		neutral: '#808080',

		primary: '#3badf6',
		danger: '#ffb93d',
		warning: '#ff595f',
		success: '#0ccfc5',

		list: ['#3badf6', '#ff8181', '#ffb93d', '#0ccfc5', '#5383ed', '#ff595f', '#ff7c43', '#30c790'],

		solarComp: ''
	},

	browser: (() => {
		// 获取设备信息
		const u = navigator.userAgent;
		const app = navigator.appVersion; // appVersion 可返回浏览器的平台和版本信息。该属性是一个只读的字符串。
		const browserLang = (navigator.browserLanguage || navigator.language).toLowerCase(); // 获取浏览器语言

		const explorer = window.navigator.userAgent.toLowerCase();
		let ver = '';
		let verInfo = null;
		// ie
		if (explorer.indexOf('msi') >= 0) {
			ver = explorer.match(/msie ([\d.]+)/)[1];
			verInfo = { type: 'IE', version: ver };
		}
		// firefox
		else if (explorer.indexOf('firefox') >= 0) {
			ver = explorer.match(/firefox\/([\d.]+)/)[1];
			verInfo = { type: 'Firefox', version: ver };
		}
		// Chrome
		else if (explorer.indexOf('chrome') >= 0) {
			ver = explorer.match(/chrome\/([\d.]+)/)[1];
			verInfo = { type: 'Chrome', version: ver };
		}
		// Opera
		else if (explorer.indexOf('opera') >= 0) {
			ver = explorer.match(/opera.([\d.]+)/)[1];
			verInfo = { type: 'Opera', version: ver };
		}
		// Safari
		else if (explorer.indexOf('Safari') >= 0) {
			ver = explorer.match(/version\/([\d.]+)/)[1];
			verInfo = { type: 'Safari', version: ver };
		}
		return {
			u,
			app,
			browserLang,
			verInfo,
			type: '',
			model: '',
			internalProcedures: '',
			brand: '',
			core: '',
			system: (function () {
				if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) return 'ios';
				// ios终端
				else if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) return 'android';
				// android终端或者uc浏览器
				else return '';
			})(),
			trident: u.indexOf('Trident') > -1, // IE内核
			presto: u.indexOf('Presto') > -1, // opera内核
			webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
			gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
			mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
			iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
			iPad: u.indexOf('iPad') > -1, // 是否iPad
			ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
			android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或者uc浏览器
			webApp: u.indexOf('Safari') == -1, // 是否web应用程序，没有头部和底部
			weixin: u.indexOf('MicroMessenger') > -1, // 是否微信
			qq: u.match(/\sQQ/i) == ' qq' // 是否QQ
		};
	})(),

	production: location.host.indexOf('solarman') >= 0, // 某些功能通过识别生产环境实现
	// resize:[],

	// remote:{//远程对象
	//		api:"http://47.88.18.157:18010/"//api基地址
	// api:"http://localhost:8080/solarman/"//api基地址
	// api:"http://btest.solarman.cn/"//api基地址
	// api:"http://pro.solarman.cn/"
	//		api:(location.hostname=="localhost"||location.hostname.indexOf("192.168")>=0)?"http://btest.solarman.cn/":"http://pro.solarman.cn/"
	// },

	languageEmptyToken: '[blank]', // 设置空词条填充的文本
	languageList: '', // 支持的语言切换列表，格式和Select组件对应；oem设置中直接赋值语言code，逗号隔开，language.js处理转成列表
	languageId: null,
	upgrade: false
};

// 拾取颜色定义
$('body').append($(`
	<div bgSolarComp class="bgSolarComp"></div>
`));
setTimeout(() => {
	stage.color.solarComp = $('[bgSolarComp]').css('background-color');
	$('[bgSolarComp]').remove();
}, 0);

// if(location.pathname.indexOf("/pro")>=0){
// 	stage.loc.baseRouter="/pro/";
// }
window.stage = stage;
window.log = {// 保存前端用的日志
	system: [],
	device: [],
	deviceControl: []
};
// $(function(){
//
// });



// WEBPACK FOOTER //
// ./src/util/stage.js